import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/components/blog/LegacyBlogRedirect.tsx");
